import { PointOfSalePage } from "@containers";
import { useEffect } from "react";
import { Strings } from "@constant";

export const PointOfSale = () => {
  useEffect(() => {
    document.title = Strings.pageTitle("Point of Sale");
  });

  return (
    <>
      <PointOfSalePage />
    </>
  );
};
